/**
 * Returns an answer array for question type `radio`
 *
 * @export
 * @param {*} answers
 * @param {*} question
 * @returns
 */
export default function(answers, question) {
    let returnAns = []
    for (let i = 1 ; i <= 5 ; i++)
        returnAns.push({
            key: '' + i,
            name: '' + i,
            label: ((i == 1) ? question.start : ((i == 5) ? question.end : '')),
            user: answers.filter((answer) => answer.value == i)
        })
    return returnAns
}
